import React, { useState } from 'react';
import { Code, ChevronDown, ChevronRight, Copy, Check } from 'lucide-react';
import { useTranslation } from '../../../../../contexts/I18nProvider';

interface SqlBlockProps {
    sql: string;
    /** Åpen fra start (resultatpanelets «SQL»-knapp) */
    defaultExpanded?: boolean;
    /** Overskrift i stedet for «Vis SQL» (flere datasett) */
    label?: string;
}

export const SqlBlock: React.FC<SqlBlockProps> = ({ sql, defaultExpanded = false, label }) => {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);
    const [copied, setCopied] = useState(false);

    const handleCopy = async (e: React.MouseEvent) => {
        e.stopPropagation();
        await navigator.clipboard.writeText(sql);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="mt-2 border rounded bg-gray-50">
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="w-full flex items-center justify-between px-3 py-2 text-xs text-gray-600 hover:bg-gray-100 transition-colors"
            >
                <div className="flex items-center gap-1.5">
                    {isExpanded ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
                    <Code size={12} />
                    <span>{label ?? t('manager.modules.claudeQuery.sql.showSql', {}, 'Vis SQL')}</span>
                </div>
                {isExpanded && (
                    <button
                        onClick={handleCopy}
                        className="flex items-center gap-1 px-2 py-0.5 text-xs text-gray-500 hover:text-gray-700 rounded"
                    >
                        {copied ? <Check size={10} className="text-green-600" /> : <Copy size={10} />}
                        {copied ? t('manager.modules.claudeQuery.sql.copied', {}, 'Kopiert') : t('manager.modules.claudeQuery.sql.copy', {}, 'Kopier')}
                    </button>
                )}
            </button>
            {isExpanded && (
                <div className="px-3 pb-3">
                    <pre className="text-xs font-mono text-gray-700 bg-white p-3 rounded border overflow-x-auto whitespace-pre-wrap">
                        {sql}
                    </pre>
                </div>
            )}
        </div>
    );
};
